module.exports = __webpack_public_path__ + "img/diu.1.410132c0.png";